export default "__VITE_ASSET__L432ybB9__"